import { render } from "./StaticContent.vue?vue&type=template&id=7a6db9b6"
import script from "./StaticContent.vue?vue&type=script&lang=js"
export * from "./StaticContent.vue?vue&type=script&lang=js"

import "./StaticContent.vue?vue&type=style&index=0&id=7a6db9b6&lang=scss"

import exportComponent from "C:\\BuildAgent\\work\\bd59560cf4570ff\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__